import { render, staticRenderFns } from "./PaymentTerms.vue?vue&type=template&id=06e73fd0&scoped=true&"
import script from "./PaymentTerms.vue?vue&type=script&lang=js&"
export * from "./PaymentTerms.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTerms.vue?vue&type=style&index=0&id=06e73fd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e73fd0",
  null
  
)

export default component.exports